import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PlayIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="play" ref={ref} {...props}>
      <path d="M7.57,20.67a.85.85,0,0,1-.35-.08.75.75,0,0,1-.4-.67V4.08A.75.75,0,0,1,8,3.46L19.36,11.4a.75.75,0,0,1,0,1.23L8,20.54A.75.75,0,0,1,7.57,20.67ZM8.32,5.52v13L17.62,12Z" />
    </Icon>
  ),
) as IconWithRender;

PlayIcon.displayName = 'PlayIcon';
PlayIcon.renderIcon = (props) => <PlayIcon {...props} />;
export default PlayIcon;
